<template>
    <v-navigation-drawer
        dark permanent
        mini-variant
        mini-variant-width="270"
        color="#430c08"
        class="locale-font">

        <v-divider/>
        <div>
            <img
                class="pl-6 default"
                src="@/assets/olaf-logo-white.png">
        </div>

        <company-setting
            class="py-4"
            @select-sidebar="setActiveMenu"
            @clear-sidebar="clearSidebar()"/>

        <v-divider class="sidebar-divider"/>

        <v-list
            class="pt-0"
            v-if="showSidebar"
            dense nav>
            <v-list-item
                v-for="item in sidebar"
                :key="item.title">
                <v-list-item-content
                    @click.stop="go(item.path, item.pathName, item.title)">
                    <div class="sidebar-item px-4 py-3 no-highlight">
                        <i
                            :class="[{ 'active-icon': item.active }, item.icon]"
                            class="mr-4 icon">
                        </i>
                        <div
                            class="icon-margin"
                            :class="[{'active-menu': item.active}]">
                            {{ item.title }}
                        </div>
                    </div>
                </v-list-item-content>
            </v-list-item>
        </v-list>
        <template v-slot:append>
            <div class="pb-2">
                <div
                    @click="logout()"
                    class="pl-3 pb-3 white-text no-highlight logout-menu">
                    <i class="mt-1 ml-2 mr-3 sign-out-icon fas fa-sign-out-alt"></i>
                    <div class="ml-2 mb-2">
                        {{ $vuetify.lang.t('$vuetify.sidebar.logOut') }}
                    </div>
                </div>
                <div class="version">{{ version }}</div>
            </div>
        </template>

        <logout-modal
            ref="logoutModal"/>

    </v-navigation-drawer>
</template>
<script>
import LogoutModal from '@/components/modal/LogoutModal'
import CompanySetting from '@/components/CompanySetting'

export default {
    data () {
        return {
            items: [
                {
                    title: this.$vuetify.lang.t('$vuetify.sidebar.dashboard'),
                    icon: 'fas fa-tachometer-alt-fast',
                    path: 'Dashboard',
                    pathName: 'dashboard',
                    active: false,
                    permission: [
                        this.$constant.permission.DASHBOARD.VIEW
                    ]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.sidebar.inquiryAttendance'),
                    icon: 'fas fa-clipboard-user',
                    path: 'InquiryAndAttendance',
                    pathName: 'inquiry-and-attendance',
                    active: false,
                    permission: [
                        this.$constant.permission.ATTENDANCE.VIEW
                    ]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.sidebar.devicesManagement'),
                    icon: 'fas fa-camera',
                    path: 'DevicesManagementList',
                    pathName: 'device-management',
                    active: false,
                    permission: [
                        this.$constant.permission.DEVICE_MANAGEMENT.VIEW
                    ]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.sidebar.employeeManagement'),
                    icon: 'fas fa-plus-circle',
                    path: 'Employees',
                    pathName: 'employees',
                    active: false,
                    permission: [
                        this.$constant.permission.EMPLOYEE_MANAGEMENT.VIEW
                    ]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.sidebar.timeTableSetting'),
                    icon: 'fas fa-alarm-clock',
                    path: 'TimeTableSetting',
                    pathName: 'time-table-setting',
                    active: false,
                    permission: [
                        this.$constant.permission.TIMETABLE_SETTING.VIEW
                    ]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.sidebar.visitor'),
                    icon: 'fas fa-user-astronaut',
                    path: 'Visitor',
                    pathName: 'visitor',
                    active: false,
                    permission: [
                        this.$constant.permission.VISITOR.VIEW
                    ]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.sidebar.blackList'),
                    icon: 'fas fa-ban',
                    path: 'Blacklist',
                    pathName: 'blacklist',
                    active: false,
                    permission: [
                        this.$constant.permission.BLACKLIST.VIEW
                    ]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.sidebar.nvrPunchLog'),
                    icon: 'fas fa-scroll nvr-icon',
                    path: 'NVRPunchLog',
                    pathName: 'nvr-punch-log',
                    active: false,
                    permission: [
                        this.$constant.permission.NVR_PUNCH_LOG.VIEW
                    ]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.sidebar.systemActivityLog'),
                    icon: 'fas fa-file-alt',
                    path: 'SystemActivityLog',
                    pathName: 'system-activity-log',
                    active: false,
                    permission: [
                        this.$constant.permission.ACTIVITY_LOG.VIEW
                    ]
                }
            ],
            userPermissions: {},
            showSidebar: false,
            sidebar: [],
            mappedTranslation: {
                Dashboard: 'dashboard',
                InquiryAndAttendance: 'inquiryAttendance',
                DevicesManagementList: 'devicesManagement',
                Employees: 'employeeManagement',
                TimeTableSetting: 'timeTableSetting',
                Visitor: 'visitor',
                Blacklist: 'blackList',
                NVRPunchLog: 'nvrPunchLog',
                SystemActivityLog: 'systemActivityLog'
            },
            version: null
        }
    },

    components: {
        CompanySetting,
        LogoutModal
    },
    computed: {
        username () {
            return localStorage.getItem('username')
        }
    },

    methods: {
        go (path, pathName) {
            this.$router.push({ name: path }, () => {})
            this.$forceUpdate()
            this.setActiveMenu(pathName)
        },

        logout () {
            this.$refs.logoutModal.openModal()
        },

        setActiveMenu (path) {
            for (let i = 0; i < this.items.length; i++) {
                if (path.includes(this.items[i].pathName) && this.items[i].pathName !== '') {
                    this.items[i].active = true
                } else {
                    this.items[i].active = false
                }
            }
        },

        clearSidebar () {
            for (let i = 0; i < this.items.length; i++) {
                this.items[i].active = false
            }
        },

        isActive (isActive) {
            if (isActive) {
                return '#d76436'
            }
        },

        async setSidebar () {
            await this.loadSelfPermission()
            for (let i = 0; i < this.items.length; i++) {
                const item = this.items[i]
                let showAble = true
                for (let j = 0; j < item.permission.length; j++) {
                    showAble = showAble && await this.hasPermission(item.permission[j])
                }
                if (showAble) {
                    this.sidebar.push(item)
                }
            }
        },

        setLangSideBar () {
            for (let i = 0; i < this.items.length; i++) {
                if (this.mappedTranslation[this.items[i].path]) {
                    this.items[i].title = this.$vuetify.lang.t(`$vuetify.sidebar.${this.mappedTranslation[this.items[i].path]}`)
                }
            }
        }
    },

    async mounted () {
        await this.setSidebar()
        this.version = await this.$store.dispatch('getVersion')
        this.showSidebar = true
        this.setActiveMenu(this.$router.currentRoute.path)
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.setLangSideBar()
            },
            deep: true
        }
    }
}
</script>
<style lang="scss" scoped>
    .sidebar-item {
        display: flex;
    }

    .v-list-item {
        &:hover {
            background-color: #ffffff22;
            cursor: pointer;
        }

        .collapse:hover {
            background-color: #ffffff22;
            cursor: pointer;
        }
    }

    // .v-list-item:hover{
    //     background-color: #ffffff22;
    //     cursor: pointer;
    // }
    // .v-list-item .collapse:hover{
    //     background-color: #ffffff22;
    //     cursor: pointer;
    // }
    .pointer {
        cursor: pointer;
    }
    .v-list {
        padding-left: 0;
        padding-right: 0;
    }
    .no-highlight {
        -webkit-touch-callout: none;    /* iOS Safari */
        -webkit-user-select: none;      /* Safari */
        -khtml-user-select: none;       /* Konqueror HTML */
        -moz-user-select: none;         /* Old versions of Firefox */
        -ms-user-select: none;          /* Internet Explorer/Edge */
        user-select: none;              /* Non-prefixed version, currently
                                           supported by Chrome, Opera and Firefox */
    }
    .img {
        padding: 1rem 0;
        width: 150px;
        opacity: 0.9;
    }
    .default {
        padding: 1rem 0;
        width: 86px;
    }
    .center {
        display: flex;
        justify-content: center;
    }
    .user {
        display: flex;
        color: white;
        padding: 1rem 0.5rem;
    }
    .username {
        display: flex;
        flex-direction: column-reverse;
        padding-left: 0.5rem;
    }
    .logout {
        color: white;
    }
    .v-list-item {
        padding: 0;
    }
    .white-text {
        color: white;
    }
    .sign-out-icon {
        font-size: 20px;
        cursor: pointer;
    }
    .icon {
        font-size: 21px;
        width: 21px;
    }
    .active-menu {
        color: #d76436;
    }
    .sidebar-divider.v-divider {
        border: 1px solid #c7c7c7 !important;
        margin: 30px 20px;
    }
    .power-by {
        font-size: 14px;
    }
    .logout-menu {
        display: flex;
        cursor: pointer;
    }
    .active-icon {
        color: #fdae8a;
    }
    .icon-margin {
        margin-top: 2px;
    }
    .nvr-icon {
        margin-left: -5px;
        margin-right: 21px !important; // 5px + px-3(16px)
    }
    .version {
        color: white;
        text-align: center;
        font-size: 12px;
    }
</style>
